export default __webpack_public_path__ + "new-marker.png";